<template>
    <div class="expenses">

        <!-- [ Header ] start -->
        <!--<Header :open="open" @openDialog="openDialog" @showMenu="showMenu" @hideMenu="hideMenu"  @refreshCashAdvanceFromHeader="refreshCashAdvancePage"/>-->
        <!-- [ Header ] end -->

        <div class="content">
            <!-- [ Menu ] start -->
            <!--<Menu :open="open" @companyName="companyName"/>-->
            <!-- [ Menu ] end -->
            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <div class="nav-tree">
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="businessUnitTasksCashAdvance" border>Business Units</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="engagementTasksCashAdvance" border>Engagements</el-radio>
                            <el-radio @change="stateChange" v-model="activeState" size="mini" label="projectTasksCashAdvance" border>Projects</el-radio>
                            <el-select class="inputs" no-data-text="no data" v-model="projectId" placeholder="Select Project" size="mini">
                                <el-option
                                        v-for="item in projects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="setValueProjectAfterSubmit(item.id, activeState)">
                                </el-option>
                            </el-select>
                        </div>
                        <el-button @click="openModalRequest(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Requst Cash Advance</el-button>
                    </div>
                    <el-tabs v-model="advancesTab" type="card" @tab-click="handleClickTabs">
                        <el-tab-pane name="requestTasksCashAdvance" label="Request Cash Advances"></el-tab-pane>
                        <el-tab-pane name="tasksCashAdvance" label="Cash Advances"></el-tab-pane>
                    </el-tabs>
                    <el-table
                            :data="expenseList"
                            style="width: 100%"
                            :cell-class-name="cellClassName"
                            :row-class-name="tableRowClassName"
                            :header-cell-class-name="headerCellClassName"
                            @cell-click="cellClick">
                        <el-table-column
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                label="No."
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="expenseDate"
                                label="Date"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="projectTaskExpenseInventoryItemId.name"
                                label="Expense Item"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="Status"
                                width="90">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status === 'Pending'"
                                           size="mini"
                                           type="info"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Submited'"
                                           size="mini"
                                           type="primary"
                                           plain
                                           v-html="advancesTab === 'tasksCashAdvance' ? 'Submited' : 'Requested' ">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Approved'"
                                           size="mini"
                                           type="success"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Rejected'"
                                           size="mini"
                                           type="danger"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Deposit'"
                                           size="mini"
                                           type="warning"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                                <el-button v-if="scope.row.status === 'Received'"
                                           size="mini"
                                           type="primary"
                                           plain
                                           v-html="scope.row.status">
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="companyClient.name"
                                label="Client"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="project.name"
                                label="Project"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="companyUser.user.fullName"
                                label="From"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="amount"
                                label="Amount"
                                width="100">
                            <template slot-scope="scope">
                                {{formatPrice(scope.row.amount)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="File"
                                width="50">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.fileId !== null"
                                           size="mini"
                                           type="primary"
                                           circle
                                           icon="el-icon-link"
                                           @click="handleShowImg(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="Operations"
                                width="250">
                            <template slot-scope="scope">
                                <div v-if="companyLayout.companyUserId === scope.row.companyUserId">
                                    <el-button
                                            v-if="scope.row.status === 'Pending'"
                                            size="mini"
                                            type="primary"
                                            plain
                                            @click="handleSubmit(scope.$index, scope.row, activeState, advancesTab)" v-html="advancesTab === 'tasksCashAdvance' ? 'Submit' : 'Request'"></el-button>
                                    <el-button
                                            v-if="scope.row.status === 'Pending' || scope.row.status === 'Rejected'"
                                            size="mini"
                                            type="primary"
                                            plain
                                            icon="el-icon-edit"
                                            :disabled="scope.row.isLocked === 1 && scope.row.status === 'Pending' || scope.row.status === 'Approved' || scope.row.status === 'Received'"
                                            @click="handleEdit(scope.$index, scope.row, activeState, advancesTab)"></el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            plain
                                            icon="el-icon-delete"
                                            :disabled="scope.row.isLocked === 1 && scope.row.status === 'Pending' || scope.row.status === 'Approved' || scope.row.status === 'Received'"
                                            @click="handleDelete(scope.$index, scope.row, activeState, advancesTab)"></el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <!--CASH ADVANCE ADD EDIT MODAL START-->
        <projectCashAdvanceModal
                @setValueProject='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="projectCashAdvanceModal"/>
        <!--CASH ADVANCE ADD EDIT MODAL END-->

        <!--REQUEST CASH ADVANCE ADD EDIT MODAL START-->
        <requestProjectCashAdvanceModal
                @setValueProject='setValueProjectAfterSubmitModal'
                :selectedRow="selectedRow"
                ref="requestProjectCashAdvanceModal"/>
        <!--REQUEST CASH ADVANCE ADD EDIT MODAL END-->


        <!--CASH ADVANCE INFO MODAL START-->
        <cashAdvanceInfoModal
                ref="cashAdvanceInfoModal"
                @refreshCashAdvancePage="setValueProjectAfterSubmitModal"/>
        <!--CASH ADVANCE INFO MODAL END-->

        <sweet-modal blocking width="400" ref="askBefore">
            <div class="ask-before">
                <h1>Action</h1>
                <el-button @click="openModal(activeState)" class="modal__btn btn" type="primary" plain size="mini">Add Cash Advance</el-button>
                <div><p>or</p></div>
                <el-button @click="openModalRequest(activeState)" class="modal__btn btn" type="primary" plain size="mini">Request Cash Advance</el-button>
            </div>
        </sweet-modal>

        <div v-if="viewerType == 1">
            <!-- <sweet-modal blocking class="nested" v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>
            </sweet-modal> -->
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import cashAdvanceInfoModal from '@/components/cash-davances/cashAdvanceInfoModal.vue'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'
  import projectCashAdvanceModal from '@/components/Projects/projectCashAdvanceModal.vue'
  import requestProjectCashAdvanceModal from '@/components/Projects/requestProjectCashAdvanceModal.vue'
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Media from '@dongido/vue-viaudio'
  export default {
    name: 'expenses',
    components: {
      // Header,
      // Menu,
      SweetModal,

      projectCashAdvanceModal,
      requestProjectCashAdvanceModal,
      cashAdvanceInfoModal,
      Media
    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mounted(){
      this.getProjects(this.activeState)
    },
    data() {
      return {
        activeState: 'projectTasksCashAdvance',
        advancesTab: 'tasksCashAdvance',
        // cashAdvanceCode: '',
        projectId: '',
        projects:[],
        // open: false,
        selectedRow:{},
        expenseList:[],
        moment:moment,
        companyNameSelect: '',
        // selectedProjectIdforDel: '',
        // selectedTaskIdforDel: '',
        slectedRowId: '',
        fileUrl: '',
        type: '',
        viewerType: '',
        allowMyProjectTaskExpenseList:true,
        allowProjectTaskExpenseList:true,
        // projectTaskExpenseHistoryList: [],
      }
    },
    methods: {
      stateChange(state){
        this.getProjects(state)
      },
      openModalAsk(){
        this.$refs['askBefore'].open()
      },
      getProjects(state){
        let myState = ''
        switch (state){
          case 'projectTasksCashAdvance':
            this.projects = [{name: 'All Projects', id: 'all'}]
            myState = 'projects'
            break;
          case 'engagementTasksCashAdvance':
            this.projects = [{name: 'All Engagements', id: 'all'}]
            myState = 'engagements'
            break;
          case 'businessUnitTasksCashAdvance':
            this.projects = [{name: 'All Business Units', id: 'all'}]
            myState = 'businessUnits'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.projects =  this.projects.concat(response.data.list)
            this.projectId = this.projects[0].id
            this.setValueProjectAfterSubmit(this.projectId, state)
          }).catch(error =>{

        })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      refreshCashAdvancePage(){
        this.setValueProjectAfterSubmit(this.projectId, this.activeState)
      },
      setValueProjectAfterSubmit(projectId, state){
        console.log('projectId, state', projectId, state)
        if(projectId === 'all'){
          this.setValueProjectAll(state, this.advancesTab)
        }else{
          this.setValueProject(projectId, state, this.advancesTab)
        }
      },
      setValueProjectAfterSubmitModal(projectId){
        if(this.projectId === 'all'){
          this.setValueProjectAll(this.activeState, this.advancesTab)
        }else{
          this.setValueProject(projectId, this.activeState, this.advancesTab)
        }
      },
      setValueProject(projectId, state, activeTab){

        const urlParts = this.buildUrl(state, activeTab)

        this.projectId = projectId
        let loader = this.$loading.show();
        this.$router.push(`/cash-advances?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            this.expenseList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      setValueProjectAll(state, activeTab){
        const urlParts = this.buildUrl(state, activeTab)
        let loader = this.$loading.show();
        this.$router.push(`/cash-advances?companyId=${this.$route.query.companyId}`)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.expenseList = response.data.list
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      // openDialog(){
      //   this.$emit('openChat2')
      // },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      handleEdit(index, row, state, activeTab) {
        const urlParts = this.buildUrl(state, activeTab)
        this.$refs['requestProjectCashAdvanceModal'].openModalFromCashAdvanceEdit(row, urlParts.myState)
      },
      handleClickTabs(tab, event){
        if(this.projectId === 'all'){
          this.setValueProjectAll(this.activeState, tab.name)
        }else{
          this.setValueProject(this.projectId, this.activeState, tab.name)
        }
      },
      handleSubmit(index, row, state, activeTab) {
        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }
        const urlParts = this.buildUrl(state, activeTab, row)
        console.log(urlParts)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/submit?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateCashAdvanceId}=${row.id}`)
          .then(response => {
            this.notification("Success", "Submit Expense", "success")
            this.setValueProjectAfterSubmit(this.projectId, state)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        console.log(index, row)
      },
      handleDelete(index, row, state, activeTab){
        const urlParts = this.buildUrl(state, activeTab)

        // this.selectedProjectIdforDel = row.projectId
        // this.selectedTaskIdforDel = row.projectTaskId
        this.selectedRowId = row.id

        this.$confirm('This will permanently delete the expenses. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.myState}/delete?${urlParts.stateCashAdvanceId}=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.setValueProjectAfterSubmit(this.projectId, state)
              loader.hide()
            })
            .catch(error => {
              // this.$refs.confirmation.close()
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      handleShowImg(index, row){
        const urlParts = this.buildUrl(this.activeState, this.advancesTab, row)
        console.log(index, row)
        if(row.projectTaskId === null){
          row.projectTaskId = 0
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/fieldInfo?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateCashAdvanceId}=${row.id}&field=file`)
          .then(response => {
            this.viewFile(response.data.fieldInfo.url)
          })
          .catch(error => {
            // this.$refs.confirmation.close()
            console.log('An error occurred:', error);
          });
      },
      viewFile(url) {
        this.fileUrl = url
        this.type = this.fileUrl.split('.').pop().toUpperCase()
        console.log('---', this.fileUrl, this.type);

        if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
          this.viewerType = 2;
          setTimeout(() => {
            console.log('-----', this.$el);
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
          }, 300);
        } else if (this.type == 'AVI' || this.type == 'MP4' || this.type == 'MOV') {
          this.viewerType = 3;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
          this.viewerType = 4;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else {
          this.viewerType = 1;
          setTimeout(() => {
            this.$refs.nestedChild.open()
          }, 300);
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      cellClick(row, column, event){
        if(column.label !== 'File' && column.label !== 'Operations'){
          const urlParts = this.buildUrl(this.activeState, this.advancesTab)
          this.openCashAdvanceModal(row.companyId, row.projectId, row.projectTaskId, row.id, urlParts.myState)
        }
      },
      openCashAdvanceModal(companyId, projectId, projectTaskId, projectTaskExpenseId, state){
        this.$refs.cashAdvanceInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      openModal(state) {
        this.$refs['askBefore'].close()
        this.$refs['projectCashAdvanceModal'].openModalFromCashAdvance(state)
      },
      openModalRequest(state) {
        this.$refs['askBefore'].close()
        const urlParts = this.buildUrl(state, 'requestTasksCashAdvance')
        this.$refs['requestProjectCashAdvanceModal'].openModalFromCashAdvance(urlParts.myState)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      buildUrl(state, activeTab, row) {
        console.log('state, activeTab, row', state, activeTab, row)
        let myState = ''
        let stateProjectId = ''
        let stateTaskId = ''
        let projectId = ''
        let taskId = ''
        let stateCashAdvanceId = ''
        switch (activeTab) {
          case 'tasksCashAdvance':
            if (state === 'projectTasksCashAdvance') {
              myState = 'projectTasksCashAdvance'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateCashAdvanceId = 'projectTaskCashAdvanceId'
            } else if (state === 'engagementTasksCashAdvance') {
              myState = 'engagementTasksCashAdvance'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            } else if (state === 'businessUnitTasksCashAdvance') {
              myState = 'businessUnitTasksCashAdvance'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            }
            break;
          case 'requestTasksCashAdvance':
            if (state === 'projectTasksCashAdvance') {
              myState = 'requestProjectTasksCashAdvance'
              stateProjectId = 'projectId'
              stateTaskId = 'projectTaskId'
              if(row){
                projectId = row.project.id
                taskId = row.projectTaskId
              }
              stateCashAdvanceId = 'projectTaskCashAdvanceId'
            } else if (state === 'engagementTasksCashAdvance') {
              myState = 'requestEngagementTasksCashAdvance'
              stateProjectId = 'engagementId'
              stateTaskId = 'engagementTaskId'
              if(row){
                projectId = row.engagement.id
                taskId = row.engagementTaskId
              }
              stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            } else if (state === 'businessUnitTasksCashAdvance') {
              myState = 'requestBusinessUnitTasksCashAdvance'
              stateProjectId = 'businessUnitId'
              stateTaskId = 'businessUnitTaskId'
              if(row){
                projectId = row.businessUnit.id
                taskId = row.businessUnitTaskId
              }
              stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            }
            break;
        }
        return {
          myState: myState,
          stateProjectId: stateProjectId,
          stateTaskId: stateTaskId,
          projectId: projectId,
          taskId: taskId,
          stateCashAdvanceId: stateCashAdvanceId
        }
      }
    },
    watch:{
      expenseList(val){
        val.forEach(i =>{
          i.expenseDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
          if(i.reimbursable === 1){
            i.reimbursable = 'Reimbursable'
          }else if(i.reimbursable === 0){
            i.reimbursable = false
          }
          if(i.isBillable === 1){
            i.isBillable = 'Billable'
          }else if(i.isBillable === 0){
            i.isBillable = false
          }
          if(i.status === 1){
            i.status = 'Pending'
          }else if(i.status === 2){
            i.status = 'Submited'
          }else if(i.status === 3){
            i.status = 'Approved'
          }else if(i.status === 4){
            i.status = 'Rejected'
          }else if(i.status === 5){
            i.status = 'Deposit'
          }else if(i.status === 6){
            i.status = 'Received'
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .expenses{
        background: #fff;
    }

    .content {
        display: flex;
        min-height: 100vh;
        padding-top: 50px;
    }

    // [ Wrapper ] start
    .wrap {
        display: flex;
        justify-content:center;
        width: 100%;
        padding: 20px 10px 10px 10px;

        &__tree {
            max-width: 1500px;
            padding: 0 0 10px 0;
        }
        &.animation{
            margin-left:260px;
            transition: margin-left 500ms ease-out, transform 500ms ease-out;
        }
    }
    // [ Wrapper ] end

    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
            &_btn{
                /*margin-left:10px;*/
            }
        }
        .el-button {
            margin-right: 10px;
        }
        .el-radio{
            margin-right:0;
        }
        .inputs{
            margin-left:10px;
        }
    }
    // [ Nav tree ] end

    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    .modal__title{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .modal__amount{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .iframe{
        width:640px;
        height:700px;
    }
    .modal__bottom{
        margin-top:20px;
    }
    .menu{
        min-height:calc(100vh - 50px);
    }
    .menu.animation{
        position: fixed;
    }
    .ask-before{
        display:flex;
        flex-direction:column;
        text-align:center;
        align-items:center;
        justify-content: center;
        .btn{
            width:180px;
            margin:5px 0;
        }
    }
</style>

